// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"48e02e06","239":"3e7cfe5e","455":"16a04883"}[chunkId] + ".chunk.js";
};